import { itemsPerPageChoices } from '@hotjar/insights-common/constants/legacy';
import { getItemsPerPage, setItemsPerPage } from '@hotjar/webapp/lib/itemsPerPage';

/**
 * Adds paging to a controller.
 * NOTE: This currently only works whe the items are set as getFilteredList().
 *
 * Usage example:
 * <paging></paging>
 *
 */
angular.module('hjApp').directive('paging', [
    '$timeout',
    function ($timeout) {
        return {
            restrict: 'E',
            replace: true,
            template:
                /* eslint-disable max-len */
                '<!-- START PAGING DIRECTIVE -->' +
                '<div>' +
                '<div class="col-md-12 pan ptm paging-row">' +
                '<div class="paging">' +
                '<pagination items-per-page="itemsPerPage" max-size="5" total-items="getTotalCount()" ng-model="currentPage" class="pagination-sm" previous-text="&lsaquo; PREV" next-text="NEXT &rsaquo;"></pagination>' +
                '<div class="per-page-selector hide-when-filter-sm">' +
                '<select class="form-control input-sm inline"' +
                'ng-options="option.value as option.label for option in paging.itemsPerPageChoices"' +
                'ng-model="itemsPerPage"' +
                'ng-change="changeItemsPerPage()">' +
                '</select>' +
                'Items per page' +
                '</div>' +
                '</div>' +
                '<div class="clear"></div>' +
                '</div>' +
                '<div class="clear"></div>' +
                '</div>' +
                '<!-- END PAGING DIRECTIVE -->',
            /* eslint-enable max-len */
            link: function (scope) {
                // when the pagination component is created, it defaults to page one and updated the currentPage
                // in order to continue from any other page we need to set it after component initialisation
                var initialCurrentPage = scope.currentPage;

                /*************************
                 * SCOPE VARIABLES
                 *************************/
                scope.itemsPerPage = scope.itemsPerPage || getItemsPerPage();
                scope.currentPage = scope.currentPage || 1;

                scope.paging = { itemsPerPageChoices };

                if (_.isUndefined(scope.getTotalCount)) {
                    scope.getTotalCount = function () {
                        return scope.getFilteredList(true).length;
                    };
                }

                /*************************
                 * SCOPE FUNCTIONS
                 *************************/
                /**
                 * Remember how many items per page the user wants.
                 */
                scope.changeItemsPerPage = function () {
                    setItemsPerPage(scope.itemsPerPage);
                };

                $timeout(function () {
                    // this is an ugly workaround because the paging directive always starts with
                    // page number 1 and thus resets the currentPage to 1 even if the value is otherwise
                    if (initialCurrentPage !== scope.currentPage) {
                        scope.currentPage = initialCurrentPage;
                    }
                    // inform others we are ready and watchers can be set
                    scope.$emit('paginationInitialzed');
                }, 100);
            }
        };
    }
]);
